import { useState, useEffect } from 'react';
import axios from 'axios';
import Loading from '../../../component/common/loading/Loading.jsx';
import ExcelDownload from '../../../component/common/button/ExcelDownload.jsx';

import { useDynamicStyle } from '../../../hooks/useDynamicStyle.js';
import * as Icons from '../../../images/icons/icons_component.js';
import * as Theme from '../../../images/icons/icons_theme';

const AftScheduled = () => {
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentDate = String(today.getDate()).padStart(2, '0');
    const currentMonth = String(today.getMonth() + 1).padStart(2, '0');
    const [searchParams, setSearchParams] = useState({
        searchCheck2: currentMonth,
        searchYear: currentYear,
        searchCheck1: currentDate,
        searchEmog: '',
    });
    const [emogList, setEmogList] = useState([]);
    const [dataList, setDataList] = useState([]);
    const [day, setDay] = useState([]);
    const [excel, setExcel] = useState([]);
    const [checkItems, setCheckItems] = useState([]);
    const [clone, setClone] = useState([]);
    const [list, setList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isSearched, setIsSearched] = useState(false);
    const [desc, setDesc] = useState('');

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSearchParams((prev) => ({
            ...prev,
            [name]: value,
        }));
    };
    const handleAllCheck = (checked) => setCheckItems(checked ? [...clone] : []);
    const handleSingleCheck = (checked, item) => {
        const originalItem = clone.find((row) => row.DETAIL_SN === item.DETAIL_SN);
        if (!originalItem) return;
        setCheckItems((prev) =>
            checked
                ? [...prev, originalItem]
                : prev.filter((i) => i.DETAIL_SN !== item.DETAIL_SN)
        );
    };

    const dataHead = ['일자', '근무시간', '전담여부', '외상팀장', '팀구분', '당직유형', '소속과', '성명'];
    const apiCall = '/trmsapi/dutyschd/get_aft_dttb_search_data_list.do';
    const excelHead = ['기관명', '일자', '근무시작시간', '근무종료시간', '전담여부', '외상팀장', '팀구분', '당직유형', '소속과', '성명'];
    const excelFileName = `${desc}_사후근무표_${searchParams.searchYear}_${searchParams.searchCheck2}`;
    const weekDays = ['일', '월', '화', '수', '목', '금', '토'];
    const week = weekDays[new Date(`${searchParams.searchYear}-${searchParams.searchCheck2}-${searchParams.searchCheck1}`).getDay()];
    const popupPropsInfo = {
        localStorageName: "tableData",
        popupAddress: "/nedis/trmsInfo/Schdul_popup.do",
    }

    const fetchInitialData = async () => {
        try {
            const response = await axios.get('/trmsapi/obthrc/newHospList.do', {
                params: {
                    grdc: "Y",
                    loca: ""
                }
            });
            setEmogList(response.data);
        } catch (error) {
            console.error('병원 목록 로딩 중 오류 발생:', error);
        }
    };

    const fetchDayList = async () => {
        try {
            const totalParams = {
                searchYyyyMm: searchParams.searchYear + searchParams.searchCheck2,
                userAuth: localStorage.getItem("userAuth"),
                userEmcd: localStorage.getItem("useremcd"),
            };
            const response = await axios.get('/trmsapi/dutyschd/get_aft_dttb_day_list.do', { params: totalParams });
            setDay(response.data);
        } catch (error) {
            console.error('날짜 목록 로딩 오류:', error);
        }
    };

    const fetchData = async () => {
        setIsLoading(true);
        try {
            const response = await axios.get(apiCall, { params: searchParams });
            setDataList(response.data.aftDttbDayList);
            setClone(response.data.aftDttbDayList);
            setIsSearched(true);
        } catch (error) {
            console.error('데이터 로딩 오류:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchExcelData = async () => {
        setIsLoading(true);
        try {
            const response = await axios.get('/trmsapi/dutyschd/get_bef_dttb_excel_data_list.do', { params: searchParams });
            setExcel(response.data.befDttbDayList);
        } catch (error) {
            console.error('데이터 로딩 오류:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const callList = async () => {
        try {
            const response = await axios.get('/trmsapi/obthrc/selectResourceInfoSubjList.do');
            setList(response.data);
        } catch (error) {
            console.error('병원 목록 로딩 중 오류 발생:', error);
        }
    }

    const renderTdClass = (item) => {
        const style = {};
        if (searchParams.searchCheck1 === item.DD) {
            style.border = "2px solid #4a90e2";
        }
        if ((item.DUE_DATE_PASS_YN === 'Y' || item.SAVEYN === 'Y' || clone[0]?.ONLY_VIEWYN === 'Y') && (currentYear + currentMonth > searchParams.searchYear + searchParams.searchCheck2) && searchParams.searchEmog !== '') {
            style.background = "#e6f0ff";
            style.color = "#003366";
            style.fontWeight = "bold";
        }
        return style;
    };

    const convertExcel = (data) => {
        const excelData = data.map((row) => ({
            기관명: row.EMOGDESC,
            일자: `${row.S_DD}/${row.WEEK}`,
            근무시작시간: `${row.SELDAY1} ${parseInt(row.S_TIME, 10)}:${row.S_MIN}`,
            근무종료시간: `${row.SELDAY2} ${parseInt(row.E_TIME, 10)}:${row.E_MIN}`,
            전담여부: row.ECSHG_AT,
            외상팀장: row.CRDT_TIMHDER,
            팀구분: row.BNDT_TEAMWON,
            당직유형: row.BNDT_TYPE === 'TY02' ? '외상당직' : '전체당직',
            소속과: list.filter((i) => i.CD === row.CLNICKWA_CD).map(item => item.CD_NM)[0],
            성명: row.NM,
        }));
        return excelData;
    };

    const isAftConfirm = () => {
        var flag = false;
        if (dataList.find((item) => item.CONFIRM_YN === 'Y')) {
            flag = true;
        };
        return flag;
    }

    const isAftDuePassed = () => {
        var flag = false;
        const start = currentYear + currentMonth + "01";
        const end = getNextYear(currentYear) + getNextMonthStr(currentMonth) + "10";
        if (!dataList.find((row) => row.BNDT_DE >= start && row.BNDT_DE <= end)) {
            flag = true;
        };
        return flag;
    }

    const checkAftEditAble = () => {
        const result = {
            isPassed: true,
            message: '',
        };
        if (isAftConfirm()) {
            result.isPassed = false;
            result.message = '이미 확정을 진행한 날짜의 데이터는 변경 할 수 없습니다.';
        } else if (isAftDuePassed()) {
            result.isPassed = false;
            result.message = '등록 기간이 지난후에는 데이터를 변경할 수 없습니다.';
        };
        return result;
    }

    const checkAftAllEditAble = () => {
        const result = {
            isPassed: true,
            message: '',
        };
        const allDay = Object.assign(day.aftDttbFirstList, day.aftDttbSecondList, {});
        if (allDay.length === allDay.filter((row) => row.DUE_DATE_PASS_YN === 'Y').length) {
            result.isPassed = false;
            result.message = `${searchParams.searchYear}년 ${searchParams.searchCheck2}월 데이터는 이미 일괄 확정된 상태입니다.`;
        } else if (isAftDuePassed()) {
            result.isPassed = false;
            result.message = '등록 기간이 지난후에는 데이터를 변경할 수 없습니다.';
        };
        return result;
    }

    const handleDeleteRow = (index) => {
        setDataList((prev) => prev.filter((_, i) => i !== index));
    };

    const handleCellChange = (rowIdx, value, name) => {
        setDataList((prev) => {
            const next = [...prev];
            const currentRow = next[rowIdx];

            if (currentRow[name] === value) return prev;
            if (value === true) value = 'Y';
            if (value === false) value = 'N';

            const updatedRow = {
                ...currentRow,
                [name]: value,
            };
            next[rowIdx] = updatedRow;
            return next;
        });
    };

    useEffect(() => {
        fetchInitialData();
        callList();
    }, []);

    useEffect(() => {
        fetchDayList();
        fetchExcelData();
        fetchData();
    }, [searchParams.searchCheck2, searchParams.searchYear, searchParams.searchEmog]);

    useEffect(() => {
        fetchData();
    }, [searchParams.searchCheck1]);

    useEffect(() => {
        const desc = emogList.find((a) => a.EMOGCODE === searchParams.searchEmog)?.EMOGDESC;
        if (desc) setDesc(desc);
    }, [searchParams.searchEmog]);

    const convertRows = (newRows) => {
        const jsonArray = newRows.map((row) => {
            return {
                bndtDe: searchParams.searchYear + searchParams.searchCheck2 + searchParams.searchCheck1,
                clnickwaCd: row.CLNICKWA_CD,
                detailSn: row.DETAIL_SN || null,
                ecshgAt: row.ECSHG_AT,
                nm: row.NM,
                bndtmanTlphonNo: row.BNDTMAN_TLPHON_NO || null,
                crdtTimhder: row.CRDT_TIMHDER,
                bndtTeamwon: row.BNDT_TEAMWON,
                workBeginDt: searchParams.searchYear + searchParams.searchCheck2 + searchParams.searchCheck1 + row.S_TM,
                workEndDt: searchParams.searchYear + searchParams.searchCheck2 + row.E_DD + row.E_TM,
                bndtType: row.BNDT_TYPE,
            };
        });
        return jsonArray;
    };

    const getNextMonthStr = (monthStr) => {
        let nextMonth = parseInt(monthStr, 10) + 1;
        if (nextMonth === 13) nextMonth = 1;
        return nextMonth < 10 ? "0" + nextMonth : "" + nextMonth;
    };

    const getNextYear = (yearStr) => {
        let nextYear = parseInt(yearStr);
        if (searchParams.searchCheck2 === '12') { nextYear += 1; }
        return nextYear;
    }

    const add = () => {
        if (searchParams.searchEmog === '') {
            alert("의료기관을 선택해주세요.");
            return;
        }
        const newRow = {
            DETAIL_SN: null,
            S_DD: searchParams.searchCheck1,
            S_TM: '',
            E_TM: '',
            E_DD: searchParams.searchCheck1,
            ECSHG_AT: 'N',
            CRDT_TIMHDER: 'N',
            BNDT_TEAMWON: '활성화팀원',
            BNDT_TYPE: 'TY01',
            CLNICKWA_CD: 'D006',
            NM: '',
            isNew: 'Y',
        };
        setDataList(prev => [...prev, newRow]);
    };

    const save = () => {
        if (searchParams.searchEmog === '') {
            alert("의료기관을 선택해주세요.");
            return;
        };
        const nJson = convertRows(dataList);
        const invalidRow = nJson.find((row, rIdx) => {
            const index = rIdx + 1;
            if (row.workBeginDt > row.workEndDt) {
                alert(`${index}열 : [근무 시작시간이 종료시간보다 빠를 수 없습니다.]`);
                return true;
            };
            if (row.workBeginDt === row.workEndDt) {
                const confirmSame = window.confirm(`${index}열 : [근무 시작시간과 종료시간이 같습니다. 저장하시겠습니까?]`);
                if (!confirmSame) {
                    return true;
                }
            };
            return false;
        });
        if (invalidRow) {
            return true; // 유효하지 않은 row 발견되면 중단
        } else {
            const confirmFin = window.confirm('현재 내용을 저장하시겠습니까?');
            if (confirmFin) {
                const url = '/trmsapi/dutyschd/update_aft_dttb_data_list.do';
                saveLogic(nJson, url);
            }
        }
    };

    const del = () => {
        if (searchParams.searchEmog === '') {
            alert("의료기관을 선택해주세요.");
            return;
        };
        if (checkItems.length === 0) {
            alert("한개 이상의 행을 선택해야 삭제할 수 있습니다.");
            return;
        };
        if (window.confirm('삭제 처리 하시겠습니까?')) {
            const nJson = convertRows(checkItems);
            const url = '/trmsapi/dutyschd/update_del_flag_aft_dttb_data_list.do';
            saveLogic(nJson, url);
        }
    };

    const upload = () => {
        if (searchParams.searchEmog === '') {
            alert("기관을 선택해주세요.");
            return false;
        } else {
            const senData = {
                emogCode: searchParams.searchEmog,
                localStorageName: 'aftSchdul',
            };

            let popup = null;

            localStorage.setItem(popupPropsInfo.localStorageName, JSON.stringify(senData));
            popup = window.open(popupPropsInfo.popupAddress, "팝업", "scrollbars=1, resizable=0, width=800, height=400, top=30, left=30");
        };
    }; 
    
    const download = async () => {
        try {
            const response = await axios.get('/trmsapi/dutyschd/download.do', {
                responseType: 'blob',
                params: {
                    tp: 'aft',
                }
            });

            const blob = new Blob([response.data], { type: response.headers['content-type'] });
            const downloadUrl = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = downloadUrl;

            const disposition = response.headers['content-disposition'];
            const match = disposition && disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            const filename = match ? decodeURIComponent(match[1].replace(/['"]/g, '')) : 'template.xlsx';

            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(downloadUrl);
        } catch (error) {
            console.error('다운로드 실패:', error);
        };
    };

    const saveLogic = async (data, url) => {
        const payload = new URLSearchParams({
            emogcode: searchParams.searchEmog,
            aftDataByJson: JSON.stringify(data),
            userId: localStorage.getItem("id"),
        });

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: payload,
            });

            if (!response.ok) {
                throw new Error(`서버 오류: ${response.status}`);
            };

            const resultText = await response.json();
            alert(resultText.resultMessage);
        } catch (error) {
            console.error('저장 중 오류 발생:', error);
            alert('저장에 실패했습니다. 관리자에게 문의하세요.');
        };
    };

    const emogSearch = () => {
        let popup = null;
        popup = window.open('/nedis/trmsInfo/DutySearch_popup.do', "팝업", "scrollbars=1, resizable=0, width=1010, height=700, top=30, left=30");
    };

    const copy = async () => {
        if (searchParams.searchEmog === '') {
            alert("의료기관을 선택해주세요.");
            return;
        };
        const response = await axios.get('/trmsapi/dutyschd/aft_bef_copy.do', {
            params: searchParams,
        });
        alert(response.resultMessage);
    };

    const conf = () => {
        if (searchParams.searchEmog === '') {
            alert("의료기관을 선택해주세요.");
            return;
        };
        var aftCheckObj = checkAftEditAble();
        if (!aftCheckObj.isPassed) {
            alert(aftCheckObj.message);
            return;
        };
        if (dataList.length === 0) {
            alert("확정 가능한 데이터가 없습니다.");
            return;
        };
        if (!window.confirm(`${dataList.length}개의 데이터를 확정처리 하시겠습니까?`)) {
            return;
        };
        if (dataList.find((row) => row.isNew === 'Y')) {
            if (!window.confirm("추가된 데이터가 존재합니다.\n저장하지 않고 확정하시겠습니까?")) {
                return;
            }
        };
        const nJson = convertRows(dataList);
        const url = '/trmsapi/dutyschd/update_confirm_flag_aft_dttb_data_list.do';
        saveLogic(nJson, url);
    };

    const Bconf = async () => {
        if (searchParams.searchEmog === '') {
            alert("의료기관을 선택해주세요.");
            return;
        };
        var aftCheckObj = checkAftAllEditAble();
        if (!aftCheckObj.isPassed) {
            alert(aftCheckObj.message);
            return;
        };
        if (dataList.find((row) => row.isNew === 'Y')) {
            if (!window.confirm("추가된 데이터가 존재합니다.\n저장하지 않고 확정하시겠습니까?")) {
                return;
            }
        };
        const url = '/trmsapi/dutyschd/update_all_confirm_flag_aft_dttb_data_list.do';
        try {
            const response = await axios.get(url, {
                params: {
                    emogcode: searchParams.searchEmog,
                    bndtDe: searchParams.searchYear + searchParams.searchCheck2,
                    userId: localStorage.getItem('id'),
                }
            });
            alert(response.data.resultMessage);
        } catch (error) {
            console.error('병원 목록 로딩 중 오류 발생:', error);
        }
    };

    const Cconf = () => {
        let popup = null;
        popup = window.open('/nedis/trmsInfo/Confirm_cancel_popup.do', "팝업", "scrollbars=1, resizable=0, width=960, height=700, top=30, left=30");
    };

    const { lightBackColor, borderColorGray } = useDynamicStyle();

    // 달력 세팅
    const dayWeek = ['일', '월', '화', '수', '목', '금', '토']
    const firstDay = day?.aftDttbList?.length > 0 && day?.aftDttbList[0]?.FULLDAY;
    const date = new Date(firstDay);
    const firstDayWeek = date.getDay();
    const startColumn = firstDayWeek + 1;

    return (
        <>
            <div className="com-search">
                <table>
                    <colgroup>
                        <col width="8%" />
                        <col width="16%" />
                        <col width="8%" />
                        <col width="20%" />
                        <col width="9%" />
                        <col width="40%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>등록년월</th>
                            <td>
                                <select
                                    id="searchYear"
                                    name="searchYear"
                                    value={searchParams.searchYear}
                                    onChange={handleInputChange}
                                >
                                    {currentMonth === '12' ?
                                        Array.from({ length: 3 }, (_, i) => {
                                            const year = (currentYear + 1 - i).toString();
                                            return (
                                                <option key={year} value={year}>
                                                    {year}년
                                                </option>
                                            );
                                        })
                                        :
                                        Array.from({ length: 3 }, (_, i) => {
                                            const year = (currentYear - i).toString();
                                            return (
                                                <option key={year} value={year}>
                                                    {year}년
                                                </option>
                                            );
                                        })
                                    }
                                </select>
                                &nbsp;
                                <select
                                    id="searchCheck2"
                                    name="searchCheck2"
                                    value={searchParams.searchCheck2}
                                    onChange={handleInputChange}
                                >
                                    {Array.from({ length: 12 }, (_, i) => {
                                        const month = String(i + 1).padStart(2, '0');
                                        return (
                                            <option key={month} value={month}>
                                                {month}월
                                            </option>
                                        );
                                    })}
                                </select>
                            </td>
                            <th>의료기관명</th>
                            <td><select
                                name='searchEmog'
                                className='w-full'
                                value={searchParams.searchEmog}
                                onChange={handleInputChange}
                            >
                                <option value="">선택</option>
                                {emogList.map(hosp => (
                                    <option key={hosp.EMOGCODE} value={hosp.EMOGCODE}>{hosp.EMOGDESC}</option>
                                ))
                                }
                            </select></td>
                            <th>엑셀 업로드</th>
                            <td className='flex'>
                                <button onClick={upload} className='search_btn bg_tr_primary'><Icons.Upload16w />엑셀 업로드</button>
                                <button onClick={download} className='excel_form_down'><Theme.Download16 className='co_black' />양식 다운로드</button>
                                <button onClick={copy} className='search_btn bg_co_black'><Icons.Copy16w />사전 근무표 복사</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div className='flex gap-6 mt-2 pl-4'>
                    {day?.aftDttbList?.length > 0 && (
                        <>
                        <div className='flex flex-col w-fit'>
                            <h5 className='self-center mb-1'>{`${searchParams.searchYear} - ${searchParams.searchCheck2}`}</h5>
                            <div className='grid grid-cols-7 gap-1'>
                                {dayWeek.map((item, idx) => (
                                    <div key={idx} className='text-center'>
                                        {item}
                                    </div>
                                ))}
                                {day.aftDttbList.map((item, index) => {
                                    return (
                                    <div key={index} className={`text-center ${index === 0 && 'col-start-' + startColumn}`}>
                                        <button
                                            type='button'
                                            name='searchCheck1'
                                            value={item.DD}
                                            onClick={(e) => handleInputChange(e)}
                                            className='scheduled_date'
                                            style={renderTdClass(item)}
                                        >
                                            {item.DD}
                                        </button>
                                    </div>
                                )})}
                            </div>
                        </div>
                        </>
                    )}
                    <div className='flex flex-col gap-3'>
                        <h5 className='bg-yellow co_dark w-fit px-2 mt-6'>** {searchParams.searchYear}년 {searchParams.searchCheck2}월 등록 가능 기간 : {searchParams.searchYear}-{searchParams.searchCheck2}-01 ~ {getNextYear(searchParams.searchYear)}-{getNextMonthStr(searchParams.searchCheck2)}-10 까지</h5>
                        <span>
                            ※ 확정된 날짜의 데이터 또는 삭제된 데이터를 변경 할 수 없습니다.<br />
                            ※ 사후 근무표 등록 가능 기간: 익월 10일까지<br />
                            ※ 매월 초 사전 근무표가 사후 근무표로 자동 복사됩니다. (엑셀업로드 또는 개별수정 가능)<br />
                            ※ 사후근무표 입력 엑셀업로드 시, 기존에 입력된 사전근무표는 삭제되고 새로 입력됩니다.
                            <br />&emsp;(사전근무표 재복사를 원할 경우, 사전근무표 복사 버튼 클릭 후 저장)
                        </span>
                    </div>
                </div>
                <div className='search_btn_wrapper excel_media_set justify-self-end'>
                    <div className='btn_container'>
                        <button onClick={emogSearch} className='search_btn bg_tr_primary'><Icons.Search16w />기관별 당직일수 조회 이동</button>
                        &nbsp;
                        <button onClick={conf} className='search_btn bg_co_green'><Icons.CheckCircle16w />확정</button>
                        <button onClick={Bconf} className='search_btn bg_co_green'><Icons.CheckCircle16w />일괄확정</button>
                        <button onClick={Cconf} className='search_btn bg_co_red'><Icons.CancelCircle16w />확정취소</button>
                        &nbsp;
                        <button onClick={add} className='search_btn bg_co_black'><Icons.AddCircle16w />추가</button>
                        <button onClick={save} className='search_btn bg_co_black'><Icons.Save16w />저장</button>
                        <button onClick={del} className='search_btn bg_co_black'><Icons.DeleteCircle16w />삭제</button>
                        <ExcelDownload
                            excelHead={excelHead}
                            excelData={convertExcel(excel)}
                            searched={isSearched}
                            dataCode={excelHead}
                            excelFileName={excelFileName}
                        />
                    </div>
                </div>
            </div>
            <div className='flex flex-col flex-grow min-h-0 h-full'>
                {isLoading ? <Loading />
                    : (
                        <>
                            <span>조회일 : {searchParams.searchYear}-{searchParams.searchCheck2}-{searchParams.searchCheck1}</span>
                            <div className='data_grid_container'>
                                <hr className={`border-t-2 mr-1-1 ${borderColorGray}`} />
                                <div className={`data_list_table ${isSearched ? 'grid-animation' : ''}`}>
                                    <table>
                                        <thead style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                            <tr>
                                                {dataHead.map((row, rIdx) => (
                                                    <>
                                                        {rIdx === 0 && (
                                                            <th>
                                                                <div className='flex justify-center'>
                                                                    {dataList.length > 0 && checkItems.length === dataList.length ?
                                                                        <Icons.CheckOk className='cursor-pointer' onClick={() => (currentYear + currentMonth + currentDate > searchParams.searchYear + searchParams.searchCheck2 + '01' && currentYear + currentMonth + currentDate < getNextYear(searchParams.searchYear) + getNextMonthStr(searchParams.searchCheck2) + '10') ? handleAllCheck(false) : ''} />
                                                                        :
                                                                        <Icons.CheckNon className='cursor-pointer' onClick={() => (currentYear + currentMonth + currentDate > searchParams.searchYear + searchParams.searchCheck2 + '01' && currentYear + currentMonth + currentDate < getNextYear(searchParams.searchYear) + getNextMonthStr(searchParams.searchCheck2) + '10') ? handleAllCheck(true) : ''} />
                                                                    }
                                                                </div>
                                                            </th>
                                                        )}
                                                        <th>{row}</th>
                                                    </>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody style={{ textAlign: "center", verticalAlign: 'middle' }}>
                                            {dataList && dataList.length > 0 ? (
                                                dataList.map((row, rowIdx) => {
                                                    const isChecked = checkItems.some(i => i.DETAIL_SN === row.DETAIL_SN);
                                                    const isEditable = row.ONLY_VIEWYN !== 'Y';
                                                    const isNew = row.isNew === 'Y';
                                                    const css = row.DEL_YN === 'Y' ? { backgroundColor: '#FFC0CB' } : {};
                                                    const oe = rowIdx % 2 === 0 ? lightBackColor : '';

                                                    return (
                                                        <tr key={row.DETAIL_SN || rowIdx} style={css} className={oe}>
                                                            <td>
                                                                {isEditable ?
                                                                    <>
                                                                        {isNew ? (
                                                                            <button onClick={() => handleDeleteRow(rowIdx)}>삭제</button>
                                                                        ) : (
                                                                            <div className='flex justify-center'>
                                                                                {isChecked ?
                                                                                    <Icons.CheckOk className='cursor-pointer' onClick={() => row.ONLY_VIEWYN === 'Y' ? '' : handleSingleCheck(false, row)} />
                                                                                    :
                                                                                    <Icons.CheckNon className='cursor-pointer' onClick={() => row.ONLY_VIEWYN === 'Y' ? '' : handleSingleCheck(true, row)} />
                                                                                }
                                                                            </div>
                                                                        )}
                                                                    </>
                                                                    :
                                                                    ''
                                                                }
                                                            </td>

                                                            <td>{row.S_DD}/{isEditable ? week : row.WEEK}</td>

                                                            <td>
                                                                {isEditable ? (
                                                                    <span>
                                                                        {row.S_DD}일&nbsp;&nbsp;
                                                                        <input
                                                                            type="text"
                                                                            name="S_TM"
                                                                            value={row.S_TM}
                                                                            maxLength={4}
                                                                            style={{ width: '45px', border: '1px solid var(--co-line)' }}
                                                                            onChange={(e) => {
                                                                                const numeric = e.target.value.replace(/[^0-9]/g, '');
                                                                                if (numeric.length <= 4) {
                                                                                    handleCellChange(rowIdx, numeric, e.target.name);
                                                                                }
                                                                            }}
                                                                            onBlur={(e) => {
                                                                                const value = e.target.value;
                                                                                if (value.length === 4) {
                                                                                    const hh = parseInt(value.slice(0, 2), 10);
                                                                                    const mm = parseInt(value.slice(2, 4), 10);
                                                                                    const isValid = hh >= 0 && hh <= 23 && mm >= 0 && mm <= 59;
                                                                                    if (!isValid) {
                                                                                        alert("잘못된 시간 형식입니다. 0000 ~ 2359 사이의 값을 입력해주세요.");
                                                                                        handleCellChange(rowIdx, "", e.target.name);
                                                                                    }
                                                                                }
                                                                            }}
                                                                        />
                                                                        &nbsp;~&nbsp;
                                                                        <select
                                                                            name="E_DD"
                                                                            value={row.E_DD}
                                                                            onChange={(e) => handleCellChange(rowIdx, e.target.value, e.target.name)}
                                                                        >
                                                                            <option value={row.S_DD}>{row.S_DD}일</option>
                                                                            <option value={String(parseInt(row.S_DD) + 1).padStart(2, '0')}>{String(parseInt(row.S_DD) + 1).padStart(2, '0')}일</option>
                                                                        </select>
                                                                        &nbsp;&nbsp;
                                                                        <input
                                                                            type="text"
                                                                            name="E_TM"
                                                                            value={row.E_TM}
                                                                            maxLength={4}
                                                                            style={{ width: '45px', border: '1px solid var(--co-line)' }}
                                                                            onChange={(e) => {
                                                                                const numeric = e.target.value.replace(/[^0-9]/g, '');
                                                                                if (numeric.length <= 4) {
                                                                                    handleCellChange(rowIdx, numeric, e.target.name);
                                                                                }
                                                                            }}
                                                                            onBlur={(e) => {
                                                                                const value = e.target.value;
                                                                                if (value.length === 4) {
                                                                                    const hh = parseInt(value.slice(0, 2), 10);
                                                                                    const mm = parseInt(value.slice(2, 4), 10);
                                                                                    const isValid = hh >= 0 && hh <= 23 && mm >= 0 && mm <= 59;
                                                                                    if (!isValid) {
                                                                                        alert("잘못된 시간 형식입니다. 0000 ~ 2359 사이의 값을 입력해주세요.");
                                                                                        handleCellChange(rowIdx, "", e.target.name);
                                                                                    }
                                                                                }
                                                                            }}
                                                                        />
                                                                    </span>
                                                                ) : (
                                                                    <span>{row.S_DD}일&nbsp;&nbsp;{row.S_TIME}:{row.S_MIN} ~ {row.E_DD}일&nbsp;&nbsp;{row.E_TIME}:{row.E_MIN}</span>
                                                                )}
                                                            </td>

                                                            <td>
                                                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                                    {(isEditable ? row.ECSHG_AT === 'Y' : row.ECSHG_AT === 'Y') ?
                                                                        <Icons.CheckOk style={{ cursor: 'pointer', opacity: !isEditable ? '0.5' : '1' }} onClick={() => !isEditable ? '' : handleCellChange(rowIdx, false, 'ECSHG_AT')} />
                                                                        :
                                                                        <Icons.CheckNon style={{ cursor: 'pointer', opacity: !isEditable ? '0.5' : '1' }} onClick={() => !isEditable ? '' : handleCellChange(rowIdx, true, 'ECSHG_AT')} />
                                                                    }
                                                                </div>
                                                            </td>

                                                            <td>
                                                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                                    {(isEditable ? row.CRDT_TIMHDER === 'Y' : row.CRDT_TIMHDER === 'Y') ?
                                                                        <Icons.CheckOk style={{ cursor: 'pointer', opacity: !isEditable ? '0.5' : '1' }} onClick={() => !isEditable ? '' : handleCellChange(rowIdx, false, 'CRDT_TIMHDER')} />
                                                                        :
                                                                        <Icons.CheckNon style={{ cursor: 'pointer', opacity: !isEditable ? '0.5' : '1' }} onClick={() => !isEditable ? '' : handleCellChange(rowIdx, true, 'CRDT_TIMHDER')} />
                                                                    }
                                                                </div>
                                                            </td>

                                                            <td>
                                                                <select
                                                                    name='BNDT_TEAMWON'
                                                                    value={row.BNDT_TEAMWON}
                                                                    disabled={!isEditable}
                                                                    onChange={(e) => handleCellChange(rowIdx, e.target.value, e.target.name)}
                                                                >
                                                                    <option value="활성화팀원">활성화팀원</option>
                                                                    <option value="On Call">On Call</option>
                                                                </select>
                                                            </td>

                                                            <td>
                                                                <select
                                                                    name='BNDT_TYPE'
                                                                    value={row.BNDT_TYPE}
                                                                    disabled={!isEditable}
                                                                    onChange={(e) => handleCellChange(rowIdx, e.target.value, e.target.name)}
                                                                >
                                                                    <option value="TY01">전체당직</option>
                                                                    <option value="TY02">외상당직</option>
                                                                </select>
                                                            </td>

                                                            <td>
                                                                <select
                                                                    name='CLNICKWA_CD'
                                                                    value={row.CLNICKWA_CD}
                                                                    disabled={!isEditable}
                                                                    onChange={(e) => handleCellChange(rowIdx, e.target.value, e.target.name)}
                                                                >
                                                                    {list.map((item) => (
                                                                        <option key={item.CD} value={item.CD}>
                                                                            {item.CD_NM}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </td>

                                                            <td>
                                                                {isEditable ? (
                                                                    <input
                                                                        type='text'
                                                                        name='NM'
                                                                        value={row.NM}
                                                                        onChange={(e) => handleCellChange(rowIdx, e.target.value, e.target.name)}
                                                                        style={{ width: '60px', border: '1px solid var(--co-line)' }}
                                                                    />
                                                                ) : (
                                                                    <span>{row.NM}</span>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            ) : (
                                                <tr>
                                                    <td colSpan={1000} style={{ padding: '0' }}><span className={`data_empty ${lightBackColor}`}><Icons.EmptySalgu />해당하는 데이터가 없습니다.</span></td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                <hr className='mr-1-1 co_border_gray' />
                            </div>
                        </>
                    )
                }
            </div>
        </ >
    );
};
export default AftScheduled;